import { StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { BaseStore } from '../base/base.store';

@Injectable({ providedIn: 'root' })
@StoreConfig(
  {
    name: 'users',
    cache: {
      ttl: 900000
    }
  })
export class UserStore extends BaseStore {

  constructor() {
    super();
  }
}
